import './App.css';


import {BrowserRouter, Routes, Route, useLocation} from 'react-router-dom'
import Login from './alertas/Login';
import CompShowalertas from './alertas/Showalertas';
import CompCreateAlerta from './alertas/Createalerta';
import CompEditBlog from './alertas/Editalertas';
import CompviewBlog from './alertas/viewalertas';
import Compviewdir from './alertas/Showdirectorio'
import Compviewact from './alertas/ViewActualizacion'
import Compviewsars from './alertas/Reunion_sars'
import CompviewERI from './alertas/Reunion_ERI'
import CompviewCIERRE from './alertas/Cierres'
import Compsaladeanalisis from './alertas/Saladeanalisis'
import CompclasificacionPTR from './alertas/ClasificacionAPTR'
import Comepicollect from './alertas/PanelFormatoBAC'
import Compbac from './bac_sarampion/home/BacSarampionHome'
import ConsentimientoPaiHome from './consentimiento_pai/home/ConsentimientoPaiHome'
import ConsentimientoAdminHome from './consentimiento_pai/admin/ConsentimientoAdminHome'
import PrivateRoute from './PrivateRoute';
import MainLayout from './layout/MainLayout'
import { AuthProvider } from './AuthContext';
import { TerritorioProvider } from './context/TerritorioContext';
import { BacAuthProvider } from './context/BacAuthContext';
import ErrorBoundaryBac from './ErrorBoundaryBac';
import { lazy, Suspense } from 'react';

// Simulacro VSP: se carga solo cuando alguien entra a /simulacro
const SimulacroApp = lazy(() => import('./simulacro/SimulacroApp'));

// Rutas que NO deben llevar el layout interno del sistema (menú/cabecera
// de Alertas) — son páginas públicas independientes, pensadas para
// verse solas en el celular de quien las abre.
const RUTAS_SIN_LAYOUT = ['/consentimiento_pai', '/consentimiento_admin', '/simulacro'];

function AppRoutes() {
  const location = useLocation();
  const sinLayout = RUTAS_SIN_LAYOUT.some(ruta => location.pathname.startsWith(ruta));

  const rutas = (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/APTR" element={<CompclasificacionPTR />} />
      <Route path="/base-epicollect5" element={<Comepicollect />} />
      <Route
        path="/bac"
        element={
          <ErrorBoundaryBac>
            <BacAuthProvider>
              <TerritorioProvider>
                <Compbac />
              </TerritorioProvider>
            </BacAuthProvider>
          </ErrorBoundaryBac>
        }
      />
      <Route path="/consentimiento_pai" element={<ConsentimientoPaiHome />} />
      <Route path="/consentimiento_admin" element={<ConsentimientoAdminHome />} />
      <Route path="/simulacro/*" element={<Suspense fallback={<div style={{ padding: 40, textAlign: "center" }}>Cargando…</div>}><SimulacroApp /></Suspense>} />
      <Route element = {<PrivateRoute/>} >
      <Route path="/app" element={<CompShowalertas />} />
      <Route path="/create" element={<CompCreateAlerta />} />
      <Route path="/edit/:id" element={<CompEditBlog/>} />
      <Route path="/view/:id" element={<CompviewBlog/>} />
      <Route path="/showdirectorio" element={<Compviewdir/>} />
      <Route path="/showact/:codigo" element={<Compviewact/>} />
      <Route path="/sars/:codigo" element={<Compviewsars key="SARS" tipoSala="SARS" />} />
      <Route path="/sara/:codigo" element={<Compviewsars key="SARA" tipoSala="SARA" />} />
      <Route path="/Eri/:codigo" element={<CompviewERI/>} />
      <Route path="/cierre/:codigo" element={<CompviewCIERRE/>} />
      <Route path="/sala" element={<Compsaladeanalisis/>} />
     </Route>
    </Routes>
  );

  return sinLayout ? rutas : <MainLayout>{rutas}</MainLayout>;
}

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;